import 'jquery';

import 'uikit'

import './components/_mach.js'; import './components/_mobile-menu.js'; import './components/_product.js'; import './components/_scroll-contact.js'; import './components/_scroll-to-top.js'; import './components/_service.js'; import './components/_sticky-header.js';